import { HStack } from '@chakra-ui/react';
import { useResendListingReportShareLinkMutation } from '@client/graphql/__generated__/main-operations';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { ListingPageContent } from '../../components/Listings/ListingPage/ListingPageContent/ListingPageContent';
import {
  ListingPageContext,
  ListingPageProvider,
} from '../../components/Listings/ListingPage/ListingPageContext';
import { SharedPage } from '../SharedPage/SharedPage';

export const SharedListingPage = () => {
  const [resendListingReportShareLink, { loading }] =
    useResendListingReportShareLinkMutation();

  const resendLink = async (token: string) => {
    await resendListingReportShareLink({ variables: { token } });
  };

  return (
    <SharedPage isResendingLink={loading} resendLink={resendLink}>
      <ListingPageProvider isViewOnly={true}>
        <HStack
          alignItems="center"
          backgroundColor="bg.main"
          flexGrow={0}
          gap={0}
          maxWidth="100vw"
          mx="auto"
        >
          <ListingPageContext.Consumer>
            {({ isLoadingListing }) => {
              return isLoadingListing ? (
                <CenterSpinner />
              ) : (
                <ListingPageContent />
              );
            }}
          </ListingPageContext.Consumer>
        </HStack>
      </ListingPageProvider>
    </SharedPage>
  );
};
